/**
 * The geometry of the Kader mark, taken from the supplied brand logo (the `K`, vector
 * export of 2026-10-21).
 *
 * It lives apart from `kadir-mark.tsx` so the path data has one home: any other renderer
 * (an Open Graph card, an export) draws from the same numbers and the logo cannot drift
 * between the page and its preview.
 *
 * The mark is four ink polygons and two gradient-filled ones; the gradients run from the
 * brand sage to the ink and give the K its fold.
 */

export const KADIR_MARK_VIEWBOX = '394 414.5 292 251';

export const KADIR_MARK_INK = '#172514';

/** Solid ink shapes, back to front. */
export const KADIR_MARK_INK_POINTS = [
  '673.41 414.78 435.28 665.22 394.42 665.22 394.44 599.17 542.29 441.77 567.83 414.78 673.41 414.78',
  '685.68 665.22 569.39 665.22 510.14 600.33 570.58 536.51 685.68 665.22',
  '505.2 466.44 486.91 485.83 394.47 485.89 394.32 414.78 504.97 414.78 505.2 466.44',
  '476.75 497.63 395.61 582.98 394.6 497.02 476.75 497.63',
] as const;

/** The two gradient-filled shapes on top of the ink. */
export const KADIR_MARK_FOLDS = [
  {
    points: '449.98 540 504.73 592.13 673.41 414.78 567.83 414.78 449.98 540',
    gradient: { x1: 656.7, y1: 374.63, x2: 497.32, y2: 547.02, from: '#7a9b54', to: '#10190e' },
  },
  {
    points: '394.32 414.78 455.92 485.89 486.91 485.83 505.2 466.44 504.97 414.78 394.32 414.78',
    gradient: { x1: 394.32, y1: 450.34, x2: 505.2, y2: 450.34, from: '#7a9b54', to: '#172514' },
  },
] as const;
